import React from "react";

export const FilterHeading: React.FC<{ heading: string }> = ({ heading }) => {
  return <p className="text-[16px] leading-[18px] text-primary font-semibold">{heading}</p>;
};
